export default {"src":"/_next/static/media/building.916acf04.svg","height":771,"width":1010};